export const genderDecoder = (gender) => {
    switch(gender) {
        case 'M': return 'Male';
        case 'F': return 'Female';
        case 'X': return 'Mixed';
        default: return '';
    }
} 